import api from "./api";
import log from "loglevel";
import { ActionContext, Module } from "vuex";
import { RootState } from "@/store";
import { deleteAdministratorInvitationUrlRequest } from "./api";

type DeleteAdministratorInvitationUrlActionContext = ActionContext<
  DeleteAdministratorInvitationUrlState,
  RootState
>;

interface DeleteAdministratorInvitationUrlState {
  volumeLicenseId: string;
  administratorInvitationUrlId: string;
}

export default {
  namespaced: true,
  state: {
    volumeLicenseId: "",
    administratorInvitationUrlId: "",
  } as DeleteAdministratorInvitationUrlState,

  actions: {
    async deleteAdministratorInvitationUrl(
      context: DeleteAdministratorInvitationUrlActionContext,
      params: deleteAdministratorInvitationUrlRequest
    ): Promise<any> {
      try {
        await api.deleteAdministratorInvitationUrl(
          params,
          context.state.volumeLicenseId,
          context.state.administratorInvitationUrlId
        );
      } catch (error) {
        log.error(error);
        throw error;
      }
    },
  },

  mutations: {
    updateVolumeLicenseId(
      state: DeleteAdministratorInvitationUrlState,
      payload: string
    ): void {
      state.volumeLicenseId = payload;
    },
    updateAdministratorInvitationUrlId(
      state: DeleteAdministratorInvitationUrlState,
      payload: string
    ): void {
      state.administratorInvitationUrlId = payload;
    },
  },
} as Module<DeleteAdministratorInvitationUrlState, RootState>;
